import { render } from "./RiProdcategory01.vue?vue&type=template&id=077a9023"
import script from "./RiProdcategory01.vue?vue&type=script&lang=js"
export * from "./RiProdcategory01.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdcategory01.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "077a9023"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('077a9023', __exports__)) {
    api.reload('077a9023', __exports__)
  }
  
  module.hot.accept("./RiProdcategory01.vue?vue&type=template&id=077a9023", () => {
    api.rerender('077a9023', render)
  })

}


export default __exports__